import { Box, Button, Stack } from '@mui/material';
import { Record as DatoRecord } from 'datocms-structured-text-utils';
import { StructuredTextGraphQlResponse } from 'react-datocms';
import { FormattedMessage } from 'react-intl';

import { useReadMore } from 'hooks/useReadMore';

import BasicText from 'components/@structured/BasicText';

interface Props<T extends DatoRecord> {
  description: StructuredTextGraphQlResponse<T>;
}

const Description = <T extends DatoRecord>({ description }: Props<T>) => {
  const { ref, readmeOpen, setReadmeOpen, truncatable } = useReadMore();

  return (
    <Stack
      direction="column"
      sx={{
        gap: 1,
        alignItems: 'flex-start',
      }}
    >
      <Box
        ref={ref}
        sx={{
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: readmeOpen ? 'initial' : 30,
          WebkitBoxOrient: 'vertical',
          wordBreak: 'break-word',
          textOverflow: 'ellipsis',
        }}
      >
        <BasicText variant="smallParagraph" content={description} />
      </Box>
      {truncatable && (
        <Button
          color="primary"
          variant="text"
          onClick={() => setReadmeOpen(readmeOpen ? false : true)}
        >
          <FormattedMessage id={readmeOpen ? 'read.less' : 'read.more'} />
        </Button>
      )}
    </Stack>
  );
};
export default Description;
